/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ActivatePrescriptionRequestBody,
  ActivatePrescriptionRequestBody$Outbound,
  ActivatePrescriptionRequestBody$outboundSchema,
} from "../components/activateprescriptionrequestbody.js";

export type PlatformKillswitchesNumberActivatePrescriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PlatformKillswitchesNumberActivatePrescriptionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  activatePrescriptionRequestBody: ActivatePrescriptionRequestBody;
};

/** @internal */
export type PlatformKillswitchesNumberActivatePrescriptionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberActivatePrescriptionSecurity$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberActivatePrescriptionSecurity$Outbound,
    PlatformKillswitchesNumberActivatePrescriptionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberActivatePrescriptionSecurityToJSON(
  platformKillswitchesNumberActivatePrescriptionSecurity:
    PlatformKillswitchesNumberActivatePrescriptionSecurity,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberActivatePrescriptionSecurity$outboundSchema.parse(
      platformKillswitchesNumberActivatePrescriptionSecurity,
    ),
  );
}

/** @internal */
export type PlatformKillswitchesNumberActivatePrescriptionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ActivatePrescriptionRequestBody: ActivatePrescriptionRequestBody$Outbound;
};

/** @internal */
export const PlatformKillswitchesNumberActivatePrescriptionRequest$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberActivatePrescriptionRequest$Outbound,
    PlatformKillswitchesNumberActivatePrescriptionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      activatePrescriptionRequestBody:
        ActivatePrescriptionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        activatePrescriptionRequestBody: "ActivatePrescriptionRequestBody",
      });
    }),
  );

export function platformKillswitchesNumberActivatePrescriptionRequestToJSON(
  platformKillswitchesNumberActivatePrescriptionRequest:
    PlatformKillswitchesNumberActivatePrescriptionRequest,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberActivatePrescriptionRequest$outboundSchema.parse(
      platformKillswitchesNumberActivatePrescriptionRequest,
    ),
  );
}
